import * as React from 'react';
import { findIndex, isEmpty, isUndefined, remove } from 'lodash';
import { Alert, Panel } from 'react-bootstrap';

import {
  createControl,
  IControlError,
  IControlSchema,
  IControlSchemaBase,
} from '../../core/Controls';
import { Dictionary } from '../../types/Dictionary';

import { ControlValueDispatcher, IDispatcher } from '../helpers/Dispatcher';
import { Component, getRandomKey, I18NString } from '../helpers/Utils';

import PanelClone from './components/PanelClone';

export interface IPanelSchema extends IControlSchemaBase {
  controls: Array<IControlSchema>;
  value: any;
  disabled?: boolean;
  isCreateRows?: boolean;
  description: I18NString;
}

interface IPanelProps {
  schema: IPanelSchema;
  api: any;
  dispatcher?: ControlValueDispatcher;
  values: any;
  errors: Dictionary<IControlError | undefined>;
  visited: Dictionary<boolean>;
  allVisited: boolean;
}

interface State {
  showHelp: boolean;
}

class PanelCtrl extends Component<IPanelProps, State> {
  private checkbox: HTMLInputElement;

  state = {
    showHelp: false,
  };

  onChange = () => {
    const { dispatcher } = this.props;
    const { id } = this.props.schema;

    let { checked } = this.checkbox;

    if (!checked) {
      for (const ctrl of this.props.schema.controls) {
        if (
          ctrl.required &&
          !ctrl.disabled &&
          Object.prototype.hasOwnProperty.call(ctrl, 'value') &&
          !isEmpty(ctrl.value)
        ) {
          checked = true;
        }
      }

      if (!isEmpty(this.rows)) checked = true;
    }

    dispatcher.onBlur(id, { checked, rows: this.rows || [] }, true, undefined);
  };

  // TODO: Za4em?
  rows = this.props?.schema?.value?.rows || [];

  // TODO: Za4em?
  checked = (): boolean => !!this.props?.schema?.value?.checked;

  _handleAddRow = (row: any) => {
    const { id } = this.props.schema;
    const rows = [...this.rows(), row];

    this.props.dispatcher.onAddValueRefresh(
      id,
      { ...this.props.schema.value, checked: this.checked, rows },
      undefined,
    );
  };

  _handleRemoveRow = (key: number, isError: boolean) => {
    const { id } = this.props.schema;

    if (isError) {
      const oldrows = [...this.rows()];
      const currentRow =
        oldrows[findIndex(oldrows, (obj: any) => obj.key === key)];

      currentRow.isError = true;
      this.props.dispatcher.onAddValueRefresh(
        id,
        { ...this.props.schema.value, checked: this.checked, rows: oldrows },
        undefined,
      );
    } else {
      const rows = remove(this.rows, (obj: any) => obj.key !== key);

      this.props.dispatcher.onAddValueRefresh(
        id,
        { ...this.props.schema.value, checked: this.checked, rows },
        undefined,
      );
    }
  };

  createRow = () => {
    const { controls } = this.props.schema;
    const row = { key: getRandomKey(), controls: [] };
    for (const ctrl of controls) {
      if (ctrl.type.toLocaleUpperCase() !== 'FILE') {
        row.controls.push({ id: `${ctrl.id}_copy_${row.key}`, name: ctrl.id });
      }
    }

    return row;
  };

  _handlerCopyPanel = () => {
    const { dispatcher, schema } = this.props;
    const currentRow = this.createRow();

    dispatcher.onAddValueRefresh(
      schema.id,
      {
        ...this.props.schema.value,
        checked: this.checked,
        rows: [...this.rows(), currentRow],
      },
      undefined,
    );
  };

  toggleShow = () => {
    this.setState(({ showHelp }) => ({
      showHelp: !showHelp,
    }));
  };

  render() {
    const controls: Array<React.ReactElement<any>> = [];
    const { api, dispatcher, schema } = this.props;

    for (const ctrl of this.props.schema.controls) {
      ctrl.disableNumber = this.props.schema.disableNumber;
      if (ctrl.type.toLocaleUpperCase() === 'NUMBER') {
        const d: any = Object.create(dispatcher);
        d.onBlur = (id, value, s, error) =>
          dispatcher.onAddValueRefresh(id, value, error);
        const element = createControl(
          ctrl,
          api,
          d,
          this.props.errors,
          this.props.values,
          this.props.visited,
          this.props.allVisited,
        );
        controls.push(React.cloneElement(element, { key: `Panel.${ctrl.id}` }));
      } else {
        const element = createControl(
          ctrl,
          api,
          dispatcher,
          this.props.errors,
          this.props.values,
          this.props.visited,
          this.props.allVisited,
        );
        controls.push(React.cloneElement(element, { key: `Panel.${ctrl.id}` }));
      }
    }
    return isUndefined(schema.visible) || schema.visible ? ( // @ts-ignore
      <Panel>
        {/*// @ts-ignore*/}
        <Panel.Heading>
          {/*// @ts-ignore*/}
          <Panel.Title>
            <div className="row">
              <div className="col-md-11" style={{ display: 'inline-flex' }}>
                {!schema.required && (
                  <input
                    type="checkbox"
                    style={{ marginRight: '10px' }}
                    disabled={this.props.schema.disabled}
                    checked={this.checked() || false}
                    onChange={this.onChange}
                    ref={(node) => {
                      this.checkbox = node;
                    }}
                  />
                )}
                <span>{`${
                  this.props.schema.disableNumber
                    ? ''
                    : this.props.schema.contentNumb
                }
                                    ${this.tr(this.props.schema.title)}`}</span>
              </div>
              {schema.description && (
                <div className="col-md-1">
                  <button
                    type="button"
                    className="btn btn-default btn-add pull-right"
                    onClick={this.toggleShow}
                    style={{ marginRight: '10px' }}
                  >
                    <span className="glyphicon glyphicon-question-sign" />
                  </button>
                </div>
              )}
            </div>
          </Panel.Title>
        </Panel.Heading>
        {/*// @ts-ignore*/}
        <Panel.Body collapsible={schema.required ? false : !this.checked}>
          {controls}
          {!isUndefined(this.props.schema.isCreateRows) &&
            this.props.schema.isCreateRows && (
              <PanelClone
                metadata={schema.controls}
                disabled={this.props.schema.disabled}
                dispatcher={dispatcher}
                api={api}
                errors={this.props.errors}
                allVisited={this.props.allVisited}
                visited={this.props.visited}
                values={this.props.values}
                rows={this.rows()}
                onAdd={this._handleAddRow}
                onCopy={this._handlerCopyPanel}
                onRemove={this._handleRemoveRow}
              />
            )}
        </Panel.Body>
        {this.state.showHelp && (
          /* @ts-ignore*/
          <Alert bsStyle="warning">{schema.description.ru}</Alert>
        )}
      </Panel>
    ) : (
      <div />
    );
  }
}

export function createPanel(
  schema: IControlSchema,
  api: any,
  dispatcher: IDispatcher = null,
  errors: Dictionary<IControlError | undefined>,
  values: any = null,
  visited: Dictionary<boolean>,
  allVisited: boolean,
): React.ReactElement<any> {
  return (
    <PanelCtrl
      schema={schema as IPanelSchema}
      api={api}
      dispatcher={dispatcher as ControlValueDispatcher}
      values={values}
      errors={errors}
      visited={visited}
      allVisited={allVisited}
    />
  );
}
